



const Assessments = () => {
    return (
        <div>
            <section>
                <h1>Hello! Welcome to EquiVate Assessments Page</h1>
            </section>
        </div>
    
    )

}

export default Assessments